export interface Profile {
  icon: string
  who: string
  situation: string
  benefit: string
}

/** "Pour qui est ce système ?" — avatar profiles of the product (not customer reviews). */
export const profiles: Profile[] = [
  {
    icon: '🌾',
    who: 'Agronome ou conseiller de terrain',
    situation:
      'Les visites de parcelles s’enchaînent et un symptôme mal interprété peut conduire à une mauvaise recommandation.',
    benefit: 'Un même processus à chaque visite, du symptôme observé à la décision argumentée.',
  },
  {
    icon: '🧪',
    who: 'Technicien agricole',
    situation: 'Prélèvements, analyses, comptes rendus : il faut relier vite ce que l’on voit à ce que disent les résultats.',
    benefit: 'Des grilles d’interprétation, des protocoles et des fiches de terrain prêtes à l’emploi.',
  },
  {
    icon: '🚜',
    who: 'Producteur',
    situation: 'Des feuilles jaunissent, la croissance ralentit : vous voulez comprendre avant de décider d’un apport.',
    benefit: 'Un atlas visuel pour vérifier dans le bon ordre avant d’intervenir.',
  },
  {
    icon: '🌱',
    who: 'Horticulteur ou maraîcher',
    situation: 'Sous serre ou en plein champ, carences, excès et stress se confondent facilement.',
    benefit: 'Des fiches comparatives pour distinguer carence, toxicité, maladie et stress.',
  },
  {
    icon: '🎓',
    who: 'Étudiant en agronomie',
    situation: 'Vous devez structurer votre raisonnement et rédiger des diagnostics clairs.',
    benefit: 'La méthode OBSERVER › COMPARER › INVESTIGUER › ANALYSER › ÉVALUER › AGIR appliquée partout.',
  },
]
